import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AiOutlineArrowLeft, AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-hot-toast";

import api from "../../services/api";

export default () => {
  const [values, setValues] = useState();

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id === "add") return setValues({});
    getUser();
  }, [id]);

  const getUser = async () => {
    try {
      const { data } = await api.get(`user&id=${id}`);
      setValues(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id === "add") {
        const { data } = await api.post("user", values);
        toast.success("Created!");
        setValues(data);
        navigate(`/user/${data.id}`);
      } else {
        const { data } = await api.put("user", values);
        setValues(data);
        toast.success("Updated!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async () => {
    try {
      if (values.role === "admin") return alert("Admin cant be deleted!");
      if (!window.confirm("Are you sure you want to delete this user?")) return;
      const { data } = await api.remove(`user&id=${id}`, values);
      toast.success("Successfully deleted !");
      navigate("/user");
    } catch (error) {
      console.error(error);
    }
  };

  if (!values) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
        <AiOutlineArrowLeft
          className="cursor-pointer"
          onClick={() => navigate("/user")}
        />
        <span>User Information</span>
      </h1>
      <div className="bg-white shadow-lg rounded-lg p-6">
        <form onSubmit={handleSubmit} className="add-user">
          {/* Section 1: Personal Details */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Primary Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  value={values.name}
                  onChange={(e) =>
                    setValues({ ...values, name: e.target.value })
                  }
                  placeholder="Enter name"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium text-gray-700"
                >
                  Username
                </label>
                <input
                  id="username"
                  value={values.username}
                  onChange={(e) =>
                    setValues({ ...values, username: e.target.value })
                  }
                  disabled={id !== "add"}
                  placeholder="Enter username"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="job_title"
                  className="block text-sm font-medium text-gray-700"
                >
                  Job title
                </label>
                <input
                  id="job_title"
                  value={values.job_title}
                  onChange={(e) =>
                    setValues({ ...values, job_title: e.target.value })
                  }
                  placeholder="Enter job title"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-6">
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <input
                  type="text"
                  id="password"
                  onChange={(e) =>
                    setValues({ ...values, password: e.target.value })
                  }
                  placeholder="Enter password"
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center justify-end space-x-2">
            {id !== "add" && (
              <button
                onClick={handleDelete}
                type="button"
                className="bg-red-800 text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
              >
                Delete
              </button>
            )}

            <button
              type="submit"
              className="bg-gray-800 text-white px-6 py-2 rounded-md hover:bg-gray-900 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
